import {
  Order,
} from '@dapi/sdk';
import {
  utils,
} from '@ama-sdk/core';
import {
  createOrder,
  MockOrder,
  RecursivePartial,
} from '@dapi/sdk/spec';
// eslint-disable-next-line import/no-cycle
import {
  orderAirItem,
} from './order-air-item';


const template: RecursivePartial<Order> = {
  id: 'V4YABI',
  creationPointOfSale: {
    pointOfSaleId: 'ATHA308AA',
    countryCode: 'GR'
  },
  creationDateTime: new utils.DateTime(),
  lastModificationDateTime: new utils.DateTime(),
  isGroupBooking: false,
  nonAirContent: true,
  air: orderAirItem,
  travelers: [],
  contacts: [],
  specialServiceRequests: [],
  services: [],
  paymentRecords: [],
  orderEligibilities: {},
  travelDocuments: []
};

export const order: MockOrder = createOrder({
  template
});

export const retrieveAcknowledgeConfirmationStatusSuccess = {
  warnings: [{code: '38126', title: 'UNABLE TO QUEUE', detail: 'No queue has been selected for PNR'}]
};

export const acknowledgeSuccess = {
  data: {}
};
